import { combineReducers } from "redux";
import {
  CartDrawerReducer,
  CartQuantityReducer,
  EditDeliveryAddressReducer,
  CartDrawerMobReducer,
  NewDeliveryAddressReducer,
  PickupContactInformationReducer,
  DocumentUploadReducer,
  StepRegReducer,
  TutorialTipsRefReducers,
  MobileMenuReducer,
  ActiveMenuReducer,
  CartPropertyUnitReducer,
} from ".";
import AccountVerificationReducer from "./AccountVerification/AccountVerificationReducer";

const rootReducer = combineReducers({
  cartQty: CartQuantityReducer,
  cartDrawer: CartDrawerReducer,
  cartDrawerMob: CartDrawerMobReducer,
  editDeliveryAddress: EditDeliveryAddressReducer,
  newDeliveryAddress: NewDeliveryAddressReducer,
  pickupContactInformation: PickupContactInformationReducer,
  documentUpload: DocumentUploadReducer,
  step: StepRegReducer,
  tutorialRefs: TutorialTipsRefReducers,
  mobileMenu: MobileMenuReducer,
  estateVerify: AccountVerificationReducer,
  activeMenu: ActiveMenuReducer,
  cartPropertyUnit: CartPropertyUnitReducer,
});

export default rootReducer;
